// Simplified Chinese (中文). Keys match en.ts; a key missing here shows the English wording. Wording to be checked by a native speaker
// (see docs/LANGUAGES.md for the words that need a second look).
export const ZH: Record<string, string> = {
  "lang.label": "语言",
  "auth.brandSub": "产品生命周期管理",
  "auth.wait": "请稍候…",
  "auth.loading": "正在加载…",
  "auth.signIn": "登录",
  "auth.signInSub": "请使用贵公司为您登记的电子邮箱地址。",
  "auth.passwordSaved": "密码已保存。请登录以继续。",
  "auth.sessionEnded": "您的会话已结束。请重新登录。",
  "auth.email": "电子邮箱地址",
  "auth.password": "密码",
  "auth.forgotLink": "忘记密码？",
  "auth.enterEmailPassword": "请输入您的电子邮箱地址和密码。",
  "auth.twoFactorCheck": "双重验证",
  "auth.recoverySub": "请输入您设置双重验证时保存的恢复码之一。每个恢复码只能使用一次。",
  "auth.codeSub": "打开您的身份验证器应用，输入为 Falcon PLM 显示的 6 位验证码。",
  "auth.recoveryCode": "恢复码",
  "auth.sixDigit": "6 位验证码",
  "auth.continue": "继续",
  "auth.useApp": "改用身份验证器应用",
  "auth.useRecovery": "手机丢失？使用恢复码",
  "auth.cancelSignOut": "取消并退出登录",
  "auth.recoveryAccepted": "恢复码已接受。您还剩 {n} 个；请在“我的账户”中生成新的恢复码。",
  "auth.resetTitle": "重置密码",
  "auth.resetSub": "请输入您的电子邮箱地址，我们会发送一个链接，供您设置新密码。",
  "auth.sendReset": "发送重置链接",
  "auth.backToSignIn": "返回登录",
  "auth.resetSent": "如果该邮箱有 Falcon 账户，重置链接已发送。链接 1 小时后失效。",
  "auth.linkUnusable": "此链接无法使用",
  "auth.requestNewLink": "申请新链接",
  "auth.welcome": "欢迎",
  "auth.welcomeName": "欢迎，{name}",
  "auth.chooseNew": "设置新密码",
  "auth.inviteSub": "请设置密码以激活您的 Falcon PLM 账户。",
  "auth.resetPasswordSub": "请为您的 Falcon PLM 账户设置新密码。",
  "auth.otherUser": "此浏览器当前登录的是 {other}。继续操作会在此处退出该账户，让 {email} 单独登录。",
  "auth.newPassword": "新密码",
  "auth.passwordHint": "至少 10 个字符。一句简短的话容易记住，又难以被猜到。",
  "auth.typeAgain": "再次输入",
  "auth.activate": "激活我的账户",
  "auth.saveNewPassword": "保存新密码",
  "auth.noMatch": "两次输入的密码不一致。",
  "auth.2fa.title": "设置双重验证登录",
  "auth.2fa.required": "您需要开启双重验证登录（因为您是管理员，或贵公司要求所有人开启）。这样即使有人知道您的密码也无法登录。",
  "auth.2fa.step1": "在手机上{b}安装身份验证器应用{eb}，例如 Google Authenticator 或 Microsoft Authenticator（免费）。",
  "auth.2fa.step2": "用该应用{b}扫描此二维码{eb}（点击 + 然后选择“扫描二维码”）。",
  "auth.2fa.qrAlt": "身份验证器应用的二维码",
  "auth.2fa.cantScan": "无法扫描？请改为在应用中输入此密钥：",
  "auth.2fa.step3": "{b}输入应用中为 Falcon PLM 显示的 6 位验证码{eb}。",
  "auth.2fa.turnOn": "开启双重验证登录",
  "auth.2fa.on": "双重验证登录已开启。",
  "auth.2fa.saveCodes": "{b}请立即保存这些恢复码。{eb}如果手机丢失，每个恢复码可登录一次。请妥善保管，例如保存在密码管理器中，或打印后锁好。这些恢复码不会再次显示。",
  "auth.2fa.copy": "复制恢复码",
  "auth.2fa.download": "下载为文本文件",
  "auth.2fa.saved": "我已保存 · 继续",
  "auth.err.BAD_LOGIN": "电子邮箱或密码不正确。",
  "auth.err.LOCKED": "错误尝试次数过多。请稍后再试，或重置密码。",
  "auth.err.BAD_CODE": "验证码不正确。请检查手机上的时间，并尝试最新的验证码。",
  "auth.err.LINK_EXPIRED": "此链接已失效或已被使用。请申请新链接。",
  "auth.err.NOT_SIGNED_IN": "您的登录已过期。请重新登录。",
  "auth.err.MFA_REQUIRED": "请输入身份验证器应用中的 6 位验证码。",
  "qch.ready": "待质检",
  "qch.readySub": "大货生产已可验货的采购订单。",
  "qch.draftSaved": "草稿已保存",
  "qch.inProgress": "进行中",
  "qch.colour": "颜色",
  "qch.productType": "产品类型",
  "qch.quantity": "数量",
  "qch.inspection": "验货",
  "qch.inspecting": "{name} 正在验此行。",
  "qch.another": "另一位验货员",
  "qch.continue": "继续验货",
  "qch.start": "开始验货",
  "qch.actionNeeded": "需要处理",
  "qch.replies": "{n} 条回复",
  "qch.openAnswer": "打开 {report} 并回复",
  "qch.actionFromYou": "需要您处理",
  "qch.nothingReady": "目前没有待质检的内容。大货生产开始后，相应的行会显示在这里。",
  "qch.newOnReports": "您的报告有新动态",
  "qch.mine": "我的验货",
  "qch.stepByStep": "分步验货",
  "qch.mineSub": "草稿和已提交的报告。",
  "qch.noInspections": "还没有验货记录。请从“待质检”开始。",
  "qch.round1": "第 1 次质检",
  "qch.round2": "第 2 次质检",
  "qch.roundN": "第 {n} 次质检",
  "pw.garment": "服装",
  "pw.footwear": "鞋类",
  "pw.product": "产品",
  "pw.general": "通用",
  "pw.measuredGarments": "已测量的服装件数",
  "pw.measuredPairs": "已测量的双数",
  "pw.measuredPieces": "已测量的件数",
  "pw.trims": "辅料和印绣",
  "pw.components": "部件",
  "pw.pcs": "件",
  "pw.pairs": "双",
  "pw.piecesWord": "件",
  "pw.pairsWord": "双",
  "step.inspection": "验货信息",
  "step.checks": "照片和检查",
  "step.workmanship": "做工",
  "step.measurements": "尺寸测量",
  "step.result": "结果",
  "sec.packing": "包装",
  "sec.labels": "标签和吊牌",
  "sec.other": "其他检查",
  "sec.video": "视频",
  "sev.none": "无缺陷",
  "sev.minor": "轻微",
  "sev.major": "严重",
  "sev.critical": "致命",
  "lvl.I": "一般检验水平 I",
  "lvl.II": "一般检验水平 II",
  "lvl.III": "一般检验水平 III",
  "lvl.S-1": "特殊检验水平 S-1",
  "lvl.S-2": "特殊检验水平 S-2",
  "lvl.S-3": "特殊检验水平 S-3",
  "lvl.S-4": "特殊检验水平 S-4",
  "lvl.100%": "100%（逐件检验）",
  "msg.photo": "请至少添加一张照片",
  "msg.answer": "请选择是或否",
  "msg.reason": "请说明问题",
  "msg.required": "此项必填",
  "msg.checkedOver": "不能超过成品数量",
  "msg.point": "请填写测量部位、尺码和实测尺寸",
  "msg.addedPhoto": "请添加照片，或删除此检查项",
  "msg.title": "请输入标题",
  "chk:Garment front": "服装正面",
  "chk:Garment back": "服装背面",
  "chk:Inside and seams": "里面和缝线",
  "chk:Carton and carton marks": "纸箱和箱唛",
  "chk:Carton label": "纸箱标签",
  "chk:Polybag": "胶袋",
  "chk:Polybag sticker": "胶袋贴纸",
  "chk:Folding": "折叠",
  "chk:Swing tag": "吊牌",
  "chk:Wash care label": "洗水唛",
  "chk:Brand label": "主唛",
  "chk:Size label": "尺码唛",
  "chk:Pair side view": "鞋子侧面",
  "chk:Top view": "俯视图",
  "chk:Sole": "鞋底",
  "chk:Inside and insole": "内里和鞋垫",
  "chk:Toe cap and heel": "鞋头和鞋跟",
  "chk:Shoe box": "鞋盒",
  "chk:Tissue and stuffing": "包装纸和填充物",
  "chk:Box label": "鞋盒标签",
  "chk:Front": "正面",
  "chk:Back": "背面",
  "chk:Inside or detail": "里面或细节",
  "chk:Inner packing": "内包装",
  "chk:Product label": "产品标签",
  "qcw.title": "质量检验",
  "qcw.steps": "步骤",
  "qcw.stepOf": "第 {n} 步，共 {total} 步",
  "qcw.moreActions": "更多操作",
  "qcw.close": "关闭",
  "qcw.removeDraft": "删除草稿",
  "qcw.back": "上一步",
  "qcw.next": "下一步",
  "qcw.submit": "提交报告",
  "qcw.nOf": "{n}/{total}",
  "qcw.alertOne": "还有 1 项需要填写才能继续",
  "qcw.alertMany": "还有 {n} 项需要填写才能继续",
  "qcw.everyPiece": "逐件检验（批量小于抽样数）",
  "qcw.everyPair": "逐双检验（批量小于抽样数）",
  "qcw.codeLetter": "字码 {letter}",
  "qcw.enterFinished": "请输入成品数量",
  "qcw.belowNote": "低于标准要求的抽样数（{n}/{total}）",
  "qcw.overOrder": "超过订单数量（{n} {unit}）。请核对数字。",
  "qcw.sizeTotal": "合计 {n}/{total} {unit}",
  "qcw.sizeNoteChecked": "已检尺码合计为 {n}，与已检数量 {total} 不符。您仍可继续。",
  "qcw.sizeNoteSample": "已检尺码合计为 {n}，与抽样数 {total} 不符。您仍可继续。",
  "qcw.tagWarn": "标记为 {list} 的照片多于填写的数量。请核对数量。",
  "qcw.shouldBe": "应为 {spec}，公差 {tol}",
  "qcw.tolNotGiven": "未注明",
  "qcw.choosePoint": "请选择测量部位和尺码",
  "qcw.diffWithin": "差值 {diff} · 在公差内",
  "qcw.diffOutside": "差值 {diff} · 超出公差 {beyond}",
  "qcw.standard": "ISO 2859-1 (ANSI/ASQ Z1.4)，正常检验，一次抽样 · {level} · AQL 致命 {c}，严重 {m}，轻微 {n}",
  "qcw.po": "采购订单",
  "qcw.style": "款号",
  "qcw.orderQty": "订单数量",
  "qcw.techpack": "工艺单",
  "qcw.newerRev": "有更新的版本（第 {n} 版）",
  "qcw.noTechpack": "此采购订单未附工艺单。",
  "qcw.noTechpackShort": "此采购订单未附工艺单",
  "qcw.sealPhotos": "{name}照片",
  "qcw.noPhotos": "没有照片。",
  "qcw.finishedQty": "可供验货的成品数量（{unit}）",
  "qcw.packedReady": "仅限本采购订单已包装好、可验货的数量（{unitWord}）",
  "qcw.checkedQty": "已检数量（{unit}）",
  "qcw.piecesChecked": "您实际检验的件数",
  "qcw.pairsChecked": "您实际检验的双数",
  "qcw.sampleRequired": "标准要求的抽样数",
  "qcw.viewTable": "查看表格",
  "qcw.reasonOptional": "原因（可选）",
  "qcw.reason": "原因",
  "qcw.sizesChecked": "已检尺码（可选）",
  "qcw.piecesInSize": "尺码 {size} 已检件数",
  "qcw.noSizes": "此采购订单行没有尺码。",
  "qcw.refCaption": "来自工艺单第 {rev} 版，随 {po} 下发",
  "qcw.noRef": "工艺单中没有参考",
  "qcw.refFor": "{name}的参考",
  "qcw.severity": "严重程度",
  "qcw.photo": "照片",
  "qcw.photoWaiting": "等待上传的照片",
  "qcw.noteOptional": "备注（可选）",
  "qcw.photoNote": "照片备注",
  "qcw.removePhoto": "删除照片",
  "qcw.waitingUpload": "等待上传…",
  "qcw.optional": "（可选）",
  "qcw.showRef": "显示工艺单中的参考",
  "qcw.refTitle": "工艺单中的参考",
  "qcw.matches": "与工艺单一致吗？",
  "qcw.yes": "是",
  "qcw.no": "否",
  "qcw.whatWrong": "有什么问题？",
  "qcw.defectsFound": "在已检的 {n} {unit}中发现的缺陷",
  "qcw.noSpec": "工艺单中没有尺寸表",
  "qcw.pomUnit": "测量部位（{unit}）",
  "qcw.tolerance": "公差",
  "qcw.size": "尺码",
  "qcw.point": "测量部位",
  "qcw.requiredSize": "要求尺寸",
  "qcw.toleranceOptional": "公差（可选）",
  "qcw.measuredSize": "实测尺寸",
  "qcw.pieceNo": "件号",
  "qcw.pieceNoOptional": "件号（可选）",
  "qcw.remove": "删除",
  "qcw.allWithin": "全部在公差内吗？",
  "qcw.sizeSpec": "尺寸表",
  "qcw.pointsOut": "超出公差的部位",
  "qcw.noSpecType": "工艺单中没有尺寸表：请输入测量部位、要求尺寸和实测尺寸。",
  "qcw.addPoint": "添加另一个部位",
  "qcw.pointNotInSpec": "尺寸表中没有的部位",
  "qcw.aqlHead": "已检 {n} {unit} · 标准要求 {total} {unit} · AQL {c} / {m} / {x}",
  "qcw.pass": "合格",
  "qcw.fail": "不合格",
  "qcw.incomplete": "未完成",
  "qcw.sampleBelow": "抽样低于标准：已检 {n} {unit}，标准要求 {total} {unit}",
  "qcw.sampleMet": "抽样符合标准",
  "qcw.found": "发现",
  "qcw.allowed": "允许",
  "qcw.ok": "合格",
  "qcw.over": "超出",
  "qcw.includesMeasurements": "其中 {n} 个来自尺寸测量",
  "qcw.takePhoto": "拍照",
  "qcw.chooseGallery": "从相册选择",
  "qcw.uploadComputer": "从电脑上传",
  "qcw.addPhotos": "添加照片",
  "qcw.srcCamera": "相机",
  "qcw.srcUpload": "从电脑上传",
  "qcw.srcGallery": "相册",
  "qcw.srcGalleryTaken": "相册 · 拍摄于 {date}",
  "qcw.takenBefore": "在本次验货开始前拍摄",
  "qcw.beforeStarted": "验货开始前",
  "qcw.checksHelp": "打开一个部分，拍照并回答每项检查。一次只能打开一个部分。",
  "qcw.trimsFrom": "来自工艺单第 {rev} 版 · {n} 项辅料",
  "qcw.trimsFromOne": "来自工艺单第 {rev} 版 · {n} 项辅料",
  "qcw.otherIntro": "用于不属于上述部分的任何内容。",
  "qcw.nothingToCheck": "没有需要检查的内容",
  "qcw.addCheck": "添加其他检查项",
  "qcw.addCheckTo": "向{title}添加其他检查项",
  "qcw.checkTitle": "检查项标题",
  "qcw.titlePh": "标题",
  "qcw.addedByInspector": "验货员添加",
  "qcw.removeCheck": "删除此检查项",
  "qcw.isOk": "是否合格？",
  "qcw.notesOptional": "备注（可选）",
  "qcw.recordVideo": "录制视频",
  "qcw.uploadVideo": "上传视频",
  "qcw.overallVideo": "整体视频",
  "qcw.videoPreparing": "正在处理（720p）…",
  "qcw.replacesVideo": "{label}（替换现有视频）",
  "qcw.videoMax": "最长约 2 分钟。",
  "qcw.addedCheck": "添加的检查项",
  "qcw.piece": "件号",
  "qcw.shouldMeasured": "应为 {spec}，实测 {measured}",
  "qcw.noPointsOut": "没有超出公差的部位。",
  "qcw.answeredNo": "回答为“否”",
  "qcw.commentsOptional": "评语（可选）",
  "qcw.waitingConnection": "等待网络连接",
  "qcw.saving": "正在保存…",
  "qcw.saved": "已保存",
  "qcw.notPicture": "该文件不是图片。",
  "qcw.videoTooLong": "视频超过约 2 分钟。请录制较短的视频。",
  "qcw.uploading": "正在上传 {n}%",
  "qcw.videoFailed": "视频无法上传。",
  "qcw.videoUploaded": "视频已上传，正在处理（720p）。",
  "qcw.removeVideoQ": "删除视频？",
  "qcw.titleLabel": "标题",
  "qcw.addCheckNote": "检查项将添加到{section}，并标记为“验货员添加”。需要至少一张照片，并选择是或否。",
  "qcw.cancel": "取消",
  "qcw.addCheckBtn": "添加检查项",
  "qcw.enterTitle": "请输入标题。",
  "qcw.removeCheckQOne": "删除检查项“{title}”及其 {n} 张照片？",
  "qcw.removeCheckQ": "删除检查项“{title}”及其 {n} 张照片？",
  "qcw.removePhotoQ": "删除这张照片？",
  "qcw.removeDraftQ": "删除此草稿？其照片和答案都将被删除。",
  "qcw.draftRemoved": "草稿已删除。",
  "qcw.stepIncomplete": "“{step}”尚未完成。",
  "qcw.photosWaiting": "仍有照片等待上传。请等到显示“已保存”。",
  "qcw.submitQ": "提交报告？提交后报告将被锁定，只能补充更多信息。",
  "qcw.submitted": "报告已提交。",
  "qcw.writeEnglish": "（请用英文填写）",
  "qcw.writeEnglishShort": "请用英文填写",
  "qcw.err.QC_INCOMPLETE": "报告尚未完成。已打开第一个有遗漏的步骤。",
  "guide.button": "缺陷指南",
  "guide.title": "缺陷分类指南",
  "guide.reminder": "仅供验货员参考 — 本指南不会出现在保存的验货报告或 PDF 中。",
  "guide.close": "关闭",
  "guide.nounGarment": "服装",
  "guide.nounFootwear": "鞋子",
  "guide.nounProduct": "产品",
  "guide.NounGarment": "服装",
  "guide.NounFootwear": "鞋子",
  "guide.NounProduct": "产品",
  "guide.criticalWhat": "安全 / 合规风险",
  "guide.criticalNote": "通常一个致命缺陷就意味着验货不合格。",
  "guide.c1": "阻燃 / 非阻燃面料用错",
  "guide.c2": "{item}中遗留危险尖锐物",
  "guide.c3": "缺少必需的防护部件",
  "guide.c4": "产品被错误标注为符合安全标准",
  "guide.c5": "任何造成即时安全或合规问题的情况",
  "guide.majorWhat": "功能 / 客户拒收",
  "guide.majorNote": "影响使用、性能或预期规格的严重缺陷。",
  "guide.m1": "拉链损坏",
  "guide.m2": "严重爆缝",
  "guide.m3": "缺少反光条",
  "guide.m4": "标签错误或颜色错误",
  "guide.m5": "尺寸明显超出公差",
  "guide.m6": "标志 / 印绣位置严重偏差",
  "guide.m7": "{Item}无法按预期使用",
  "guide.minorWhat": "外观 / 轻微做工问题",
  "guide.minorNote": "不会实质影响安全或正常功能的小问题。",
  "guide.n1": "线头",
  "guide.n2": "针距轻微不匀",
  "guide.n3": "轻微外观瑕疵",
  "guide.n4": "标签位置轻微偏差",
  "guide.priority": "如客户规格、已批准的工艺单、个人防护装备 (PPE) 要求或适用标准对分类有规定，以其为准。",
  "std.title": "质检标准：抽样数和允许缺陷数",
  "std.fewer": "如果实际检验件数少于要求，允许缺陷数按实际检验数量计算。",
  "std.all": "100%：逐件检验所有成品，不允许任何缺陷。",
  "std.finished": "成品数量（件）",
  "std.sample": "要求抽样数",
  "std.critical": "允许致命缺陷",
  "std.major": "允许严重缺陷",
  "std.minor": "允许轻微缺陷",
  "std.andMore": " 及以上",
  "std.orAll": " 或不足时全检",
  // ---- Legal documents: the agreement screen and the footer links (the documents themselves stay English) -------------
  "legal.title": "继续之前",
  "legal.intro": "请阅读并同意以下文件，以便在 {org} 中使用 Falcon PLM。",
  "legal.updated": "法律文件已更新（版本 {version}）。请阅读并再次同意后继续。",
  "legal.terms": "服务条款",
  "legal.privacy": "隐私政策",
  "legal.dpa": "数据处理协议",
  "legal.subprocessors": "次级处理方",
  "legal.agreeTerms": "我同意{terms}，并已阅读{privacy}",
  "legal.agreeDpa": "我代表 {org} 接受{dpa}",
  "legal.dpaNote": "作为主管理员，您还需代表您的组织接受数据处理协议。",
  "legal.englishDocs": "文件将在新标签页中打开，内容为英文。",
  "legal.continue": "同意并继续",
  "legal.tickTerms": "请勾选方框表示同意后再继续。",
  "legal.tickDpa": "请勾选方框接受数据处理协议后再继续。",
  "legal.version": "版本 {version}",
  "legal.englishNote": "本文件为英文版本。如有不清楚之处，请咨询您组织的管理员。",
  "legal.footTerms": "条款",
  "legal.footPrivacy": "隐私",
  "legal.footDpa": "数据处理",
  "legal.footSub": "次级处理方",
};
